import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.checkInterval = setInterval(() => {
      if (window.TomSelect) {
        clearInterval(this.checkInterval)
        this.initializeTomSelect()
      }
    }, 50)
  }

  initializeTomSelect() {
    if (this.element.tomselect) return;

    this.select = new window.TomSelect(this.element, {
      plugins: ['remove_button'],
      create: false,
      placeholder: 'Select Assignee',
      hideSelected: true,
      allowEmptyOption: false,
      wrapperClass: 'ts-wrapper tutorhub-select',
      controlClass: 'ts-control'
    })
  }

  disconnect() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
    if (this.select) {
      this.select.destroy()
    }
  }
}
